/* eslint-disable react/prop-types */
import React from 'react';
import { Redirect } from 'react-router-dom';

// Terminal for a URL that matches no real route. Rendering nothing (the previous
// behaviour of the `*` route) leaves the user on a blank page with a URL that looks
// legitimate, so send them somewhere real instead — `to` says where, since an unknown
// path outside the app belongs on the login screen while one under /app belongs on the
// portal home.
const NotFound = ({ to }) => <Redirect to={to} />;

export default NotFound;
